export default defineNuxtPlugin(() => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/sw.js') // Vite PWA compiles sw.ts to sw.js
      .then((registration: ServiceWorkerRegistration) => {
        if (process.env.NODE_ENV !== 'production') console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch((error: Error) => {
        console.error('Service Worker registration failed:', error);
      });
  }
});
